module.exports = __webpack_public_path__ + "media/assets/images/patient-de65551ff147ad65edf0b324a110495b.svg";